<!-- 组件1   单图 -->
<template>
     <div class="ThemeThree">
        <div class="leftContent" v-if='ItemDate.pictureAndLinkVOS[0]' @click="jumpUrl(ItemDate.componentForwardType,ItemDate.pictureAndLinkVOS[0])">
         <img :src="ItemDate.pictureAndLinkVOS[0].pic" alt="" />
        </div>
        <div class="content">
          <div  v-if='ItemDate.pictureAndLinkVOS[1]' @click="jumpUrl(ItemDate.componentForwardType,ItemDate.pictureAndLinkVOS[1])">
           <img :src="ItemDate.pictureAndLinkVOS[1].pic" alt="" />
          </div>
          <div v-if='ItemDate.pictureAndLinkVOS[2].pic' @click="jumpUrl(ItemDate.componentForwardType,ItemDate.pictureAndLinkVOS[2])">
            <img :src="ItemDate.pictureAndLinkVOS[2].pic" alt="" />
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
    </div>
</template>
<script>
import {
    GetCoupon
  } from '../../api/topicPage.js'
  import {Toast} from "vant";
  export default {
    name: "ThemeThree",
    data() {
      return {
      }
    },
       components: {
    [Toast.name]: Toast,
  },
    props: {
        // 滚动数组
        ItemDate: {
            type: Object
        },
         token: {
            type: String
        },
    },
    created() {
       console.log('ThemeThree',this.ItemDate)
    },
    methods: {
       // 手动领取优惠券
    getCouponFun(access_token,couponId) {
      GetCoupon(access_token,couponId).then((data) => {
          if(data.data.code==200){
             this.$toast(data.data.msg)
              this.reload();
          }else{
              this.$toast("已领取")
            
        }
      })
    },
        jumpUrl(UrlType,item){
          // 跳转类型 1：链接 2：优惠券 3：商品 4：不跳转
          if(UrlType==1){
            //  this.$toast('1链接')
             let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
              this.url = item.link;
              // console.log(window.WebViewJavascriptBridge);
              if (isiOS) {
                window.webkit.messageHandlers.jumpList.postMessage(this.url)
              } else {
                this.$bridge.callHandler("jumpList", this.url, res => {
                
                });
              }
              //  window.location.href=this.ItemDate.pictureAndLinkVOS[0].link
          }else if(UrlType==2){
            // 领取优惠券
            //  this.$toast('2优惠券')
             let couponId=item.couponVOS[0].id
              this.getCouponFun(this.token, couponId)
          }else if(UrlType==3){
              // this.$toast('3商品')
             console.log(item.productVOS[0])
            //  alert(item.productVOS[0].id+'JIA'+item.productVOS[0].isRecentExpiration)
            // 3：跳转商品详情  
            this.jumpDetail(item.productVOS[0].id,item.productVOS[0].isRecentExpiration)
          }
        },
         // 点击跳转详情页   js跳转app
      jumpDetail(id, isRecentExpiration) {
        // alert(id+'我是'+isRecentExpiration)
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let detailsData = {
          goods_id: id,
          isRecentExpiration: isRecentExpiration,
        }
        if (isiOS) {
          window.webkit.messageHandlers.jumpGoodsDetail.postMessage(detailsData)
        } else {
          this.$bridge.callHandler("jumpGoodsDetail", detailsData, res => {});
        }
      },
    },
     //   注册方法
    mounted() {

    }
  }
</script>
<style lang="scss" scoped>
.ThemeThree {
    width:100%;
    display: block;
    height: auto;
   .leftContent {
      height: 100%;
      width: 50%;
      /* width: calc(1.56rem); */
      float: left;
      overflow: hidden;
       height:1.4rem;
       img {
          width: 100%;
          height: 100%;
          float: left;
        }
    }
    .content {
      height: 100%;
      /* width: 1.56rem; */
      width:50%;
      float: right;
      overflow: hidden;
      div:nth-child(1){
        width: 100%;
        height: 0.7rem;
        img {
          width: 100%;
          height: 100%;
          float: left;
        }
      }
      div:nth-child(2) {
        width: 100%;
        height: 0.7rem;
          img {
          width: 100%;
          height: 100%;
          float: left;
        }
      }
    }

    .clear{
      clear: both;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ActivityTheme/ThemeThree.vue